import { AppPartType } from "@lhd/features/Apps/AppForm/types";
import { Checkbox, Form, Input, Radio } from "antd";
import { FormInstance } from "antd/es/form/Form";
import { Dispatch, FC, SetStateAction, useEffect } from "react";

import { COLUMN_WIDTH } from "@lhd/features/Apps/AppForm/constants";
import { ERRORS_MESSAGE } from "@lhd/constants";
import OptionAdd from "../commons/OptionAdd";

type PropsType = {
  form: FormInstance<AppPartType>;
  getFieldClassName?: (name: string) => string;
  isClicked?: boolean;
  blurFields?: Record<number, boolean>;
  setBlurFields?: Dispatch<SetStateAction<Record<number, boolean>>>;
};

const CheckBoxSetting: FC<PropsType> = ({
  form,
  getFieldClassName,
  isClicked,
  blurFields,
  setBlurFields,
}) => {
  const options = Form.useWatch(["item_config_data", "options"], form);
  useEffect(() => {
    if (Array.isArray(options) && Object.keys(options[0]).length === 0) {
      form.setFieldValue(
        ["item_config_data", "options"],
        [
          { text: "サンプル1", value: "サンプル1" },
          { text: "サンプル2", value: "サンプル2" },
        ],
      );
    }
    if (Array.isArray(options) && options.length) {
      let total = 0;
      options.forEach((option) => {
        const span = document.createElement("span");
        span.textContent = option?.text || "";
        span.classList.add("span-class");
        document.body.append(span);
        const spanWidth = (span as HTMLElement).offsetWidth;
        total = total + spanWidth + 55;
        span.style.display = "none";
      });
      form.setFieldValue(
        ["item_config_data", "minW"],
        Math.ceil(total / COLUMN_WIDTH),
      );
      form.setFieldValue(
        ["item_config_data", "w"],
        Math.ceil(total / COLUMN_WIDTH),
      );
    }
  }, [options, form]);

  return (
    <>
      <Form.Item name={["item_config_data", "minW"]} hidden />
      <Form.Item name={["item_config_data", "w"]} hidden />

      <Form.Item
        label="フィールド名"
        name="name"
        rules={[{ required: true, message: ERRORS_MESSAGE.REQUIRED }]}
        className={`${getFieldClassName?.("name")}`}
      >
        <Input />
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        name="is_hide_name"
        style={{ marginBottom: "0.5rem" }}
      >
        <Checkbox>フィールド名を表示しない</Checkbox>
      </Form.Item>
      <Form.Item valuePropName="checked" name="is_required_field">
        <Checkbox>必須項目にする</Checkbox>
      </Form.Item>
      <div style={{ marginBottom: "0.5rem" }}>項目と順番</div>
      <OptionAdd
        isClicked={isClicked}
        blurFields={blurFields}
        setBlurFields={setBlurFields}
      />
      <Form.Item
        label="並び"
        name={["item_config_data", "layout"]}
        style={{ marginTop: 10 }}
      >
        <Radio.Group
          options={[
            { label: "横", value: "horizontal" },
            { label: "縦", value: "vertical" },
          ]}
        />
      </Form.Item>
      <Form.Item
        label="フィルードコード"
        name="field_code"
        rules={[{ required: true, message: ERRORS_MESSAGE.REQUIRED }]}
        className={`${getFieldClassName?.("field_code")}`}
      >
        <Input />
      </Form.Item>
    </>
  );
};

export default CheckBoxSetting;
